/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { Box, Button, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import noDataImage from '../../assets/images/page-not-found.svg'
import { ROUTES } from '../../helpers/constants'
import { getSchoolUrl } from '../../helpers/utils'

function PageNotFound({ params }) {
  const { t } = useTranslation()
  const history = useHistory()
  return (
    <Box height="100%" pt={5} pb={5}>
      <Box
        align="center"
        display="flex"
        alignItems="center"
        flexDirection="column"
        justifyContent="center"
      >
        <img width="350px" src={noDataImage} alt="no data" />
        <Typography component="h2" variant="h3" color="textPrimary" gutterBottom>
          <Box component="span" fontWeight="fontWeightMedium">
            {t('oops')}
          </Box>
        </Typography>
        <Typography component="h6" variant="h5" color="textPrimary" gutterBottom>
          <Box component="span" fontWeight="fontWeightMedium">
            {t('looksLikeYouAreLost')}
          </Box>
        </Typography>
        <Typography component="h6" variant="body2" color="textPrimary" gutterBottom>
          <Box component="span" fontWeight="fontWeightMedium">
            {t('thePageYouAreLookingForCouldNotBeFound')}
          </Box>
        </Typography>
        {!!params.district && (
          <Box mt={3}>
            <Button
              className="text-transform-none"
              size="large"
              variant="contained"
              disableElevation
              color="primary"
              onClick={() => {
                const url = getSchoolUrl({ ...params, to: ROUTES.DASHBOARD })
                history.replace(url)
              }}
            >
              {t('backToHome')}
            </Button>
          </Box>
        )}
      </Box>
    </Box>
  )
}

PageNotFound.propTypes = {
  params: {},
}

PageNotFound.defaultProps = {
  params: PropTypes.object,
}

export default PageNotFound
